
/* injects from baggage-loader */
require('./style.styl');

import React from 'react'
import PropTypes from 'prop-types'
import {Link} from 'react-router'
import VectorImage from 'components/VectorImage'
import logo from './images/logo.svg'
import classnames from 'classnames'

const sizes = {
  big: ['320px', '57px'],
  medium: ['220px', '32px'],
  small: ['128px', '22px']
}

export default class Logo extends React.Component {
  static propTypes = {
    size: PropTypes.oneOf(['big', 'medium', 'small']),
    className: PropTypes.string,
    link: PropTypes.bool,
    inverted: PropTypes.bool,
    text: PropTypes.string,
    to: PropTypes.string
  }

  static defaultProps = {
    size: 'small'
  }

  render() {
    const {className, inverted} = this.props

    return (
      <div className={classnames('logo', className, {'is-inverted': inverted})}>
        {this.renderLink()}
      </div>
    )
  }

  renderLink() {
    const {size, link, to} = this.props
    const [width, height] = sizes[size]
    const Icon = <VectorImage className='logo_image' source={logo} width={width} height={height} />

    if (!link) return Icon

    if (to) {
      return (
        <a href={to}>
          {Icon}
          {this.renderText()}
        </a>
      )
    } else {
      return (
        <Link to='/'>
          {Icon}
          {this.renderText()}
        </Link>
      )
    }
  }

  renderText() {
    const {text} = this.props

    if (!text) return null

    return <span className='logo_text'>{text}</span>
  }
}



// WEBPACK FOOTER //
// ./client/components/Logo/index.js